export var auth = function auth(siteApi) {
  return {
    postToken: function postToken(username, password) {
      return siteApi.post('/auth/token', {
        username: username,
        password: password,
        grant_type: 'password',
        client_id: 'relcore-site'
      });
    },
    password: {
      put: function put(currentPassword, newPassword) {
        return siteApi.put('/auth/password', {
          currentPassword: currentPassword,
          newPassword: newPassword
        });
      }
    }
  };
};